function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" {...props}><g fill="none" fillRule="evenodd" transform="translate(1 1)"><circle cx="16" cy="16" r="16" fill="#F6F7FB" stroke="#D7DBE9" /><g fill="#6A6D7B" transform="translate(8 14.4)"><circle cx="1.6" cy="1.6" r="1.6" /><circle cx="8" cy="1.6" r="1.6" /><circle cx="14.4" cy="1.6" r="1.6" /></g></g></svg>;
});